import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useCallback } from 'react';
import { formInputDataChangedThunk } from 'state/formData/formData.thunks';
import { selectFieldIdValue } from 'state/selectors';

export function useFormFieldData<T = unknown>(fieldId: string, defaultValue?: T) {
  const tabId = useAssertedActiveTabId();
  const fieldValue = useAppSelector(state => selectFieldIdValue(state, tabId, fieldId));

  const value = (fieldValue ?? defaultValue) as T;

  const dispatch = useThunkDispatch();

  const setValue = useCallback(
    (newValue: T) => {
      dispatch(formInputDataChangedThunk(tabId, tabId, fieldId, newValue as Readonly<T>));
    },
    [dispatch, tabId, fieldId],
  );

  return [value, setValue] as const;
}
